import React from 'react';
import { Collapse, Checkbox, Divider } from 'antd';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Icon from '@mui/material/Icon';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { format, parseISO } from 'date-fns';

const { Panel } = Collapse;

const MarkedBoxList = (props) => {

    const build_check_process = (order) => {
        return (
            <Checkbox
                style={{ marginRight: '15px' }}
                checked={order ? (order.checked === 1 ? true : false) : false}
                onClick={(event) => {
                    event.stopPropagation();
                }}
                onChange={() => {
                    props.updateDataOrdersChecked(order);
                }}
            ></Checkbox>
        );
    };

    const genExtra = (order) => {
        return (
            <div>

                <IconButton
                    style={{ marginRight: '10px' }}
                    color='primary'
                    aria-label='pdf'
                    onClick={(e) => {
                        e.stopPropagation();
                        props.displayPDF(order);
                    }}
                >
                    <PictureAsPdfIcon />
                </IconButton>
                
                {build_check_process(order)}

            </div>
        );
    };

    const renderPanel = (key, d, filterFunc) => {
        return (
            <Panel
                style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
                key={key + 1}
                extra={genExtra(d)}
                header={
                    <>
                        <strong style={{ marginRight: '14px', fontSize: '0.7em' }}>{`Orden: ${d.id}`}</strong>
                        <strong style={{ marginRight: '14px', fontSize: '0.7em' }}>{`Cliente: ${d.ordersDetail.length > 0 ? d.ordersDetail[0].productPrice ? d.ordersDetail[0].productPrice.client ? d.ordersDetail[0].productPrice.client.name : '' : '' : ''}`}</strong>
                        <Chip style={{ marginLeft: '14px', fontSize: '0.7em' }} label={`Entrega: ${d.date_delivery ? format(parseISO(d.date_delivery), 'dd-MM-yyyy HH:mm:ss') : 'INMEDIATA'}`} size='small' color="warning" variant="outlined" />
                    </>
                }
            >
                {
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                Dirección de envío: {d.address_delivery}
                            </span>
                        </Grid>
                        <Divider style={{ marginTop: '-1px', marginBottom: '-10px' }} />
                        <Grid container spacing={1}>
                            <Grid item xs={2} md={2}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                    Producto
                                </span>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                    Color
                                </span>
                            </Grid>
                            <Grid item xs={1} md={1}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                    KG
                                </span>
                            </Grid>
                            <Grid item xs={1} md={1}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                    MTS
                                </span>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                    Proceso Asignado
                                </span>
                            </Grid>


                        </Grid>
                        {
                            d.ordersDetail.filter(filterFunc).map((od, key) => {
                                return (
                                    <Grid key={key + 'itemOd'} container spacing={1}>
                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                {od.productPrice ? od.productPrice.product ? od.productPrice.product.ref : '' : ''}
                                            </span>
                                        </Grid>
                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                {od.color ? od.color.cod : ''}
                                            </span>
                                        </Grid>
                                        {od.type_quantity === 'KG' ?
                                            <Grid item xs={1} md={1}>
                                                <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                                                    {od.quantity ? od.quantity : ''}
                                                </span>
                                            </Grid>

                                            :
                                            <Grid item xs={1} md={1}>
                                                <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                    {od.productPrice.product.productWeight.length > 0 ?
                                                        (Math.round(od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter).toFixed(2)
                                                        :
                                                        'N.A'
                                                    }
                                                </span>
                                            </Grid>

                                        }

                                        {od.type_quantity === 'MTS' ?

                                            <Grid item xs={1} md={1}>
                                                <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                                                    {od.quantity ? od.quantity : ''}
                                                </span>
                                            </Grid>

                                            :
                                            <Grid item xs={1} md={1}>
                                                <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                    {od.productPrice.product.productWeight.length > 0 ?
                                                        (Math.round(od.quantity * od.productPrice.product.productWeight[0].meter) / od.productPrice.product.productWeight[0].kilo).toFixed(2)
                                                        :
                                                        'N.A'
                                                    }
                                                </span>
                                            </Grid>


                                        }


                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                {od.cod_process ? od.cod_process : ''}
                                            </span>
                                        </Grid>

                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '9px' }}>
                                                <BasicPopconfirm
                                                    label='Eliminar orden'
                                                    title='¿Seguro/a que deseas eliminar este producto?'
                                                    onConfirm={() => { props.deleteOrderDetail(od) }}
                                                    button={
                                                        <IconButton color="error" aria-label="delete" onClick={(e) => e.stopPropagation()}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    }
                                                />
                                            </span>
                                            <span style={{ fontSize: '9px' }}>
                                                <IconButton size='small' onClick={() => { props.viewColor(od); }}>
                                                    <Icon>color_lens</Icon>
                                                </IconButton>
                                            </span>
                                            <span style={{ fontSize: '9px' }}>
                                                <IconButton size='small' onClick={() => { props.viewQR(od, d.uuid); }}>
                                                    <Icon>qr_code</Icon>
                                                </IconButton>
                                            </span>
                                            <span style={{ fontSize: '9px' }}>
                                                <IconButton size='small' onClick={() => { props.setEditOrder(od, d); }}>
                                                    <Icon>content_cut</Icon>
                                                </IconButton>
                                            </span>
                                            <span style={{ fontSize: '9px' }}>
                                                <BasicPopconfirm
                                                    label='Eliminar orden'
                                                    title='¿Seguro/a que lo imprimiste y quieres dejarlo en bandeja de IMPRESOS?'
                                                    onConfirm={() => { props.readyOrderDetail(od) }}
                                                    button={
                                                        <IconButton size='small' onClick={(e) => e.stopPropagation()}>
                                                        <Icon>check</Icon>
                                                        </IconButton>
                                                    }
                                                />
                                            </span>

                                            <span style={{ fontSize: '9px' }}>
                                                <select
                                                    key={od.uuid}
                                                    style={{ fontSize: '13px', padding: '2px' }}
                                                    data-uuid={od.uuid}
                                                >
                                                    {
                                                        props.process.filter((p) => p.cod !== 'ALIS').map((obj) =>

                                                            <option
                                                                key={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                                                                value={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                                                            >
                                                                {obj.name}
                                                            </option>

                                                        )}
                                                </select>
                                            </span>

                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                        <Grid container spacing={1}>
                            <Grid item xs={2} md={2}>
                            </Grid>
                            <Grid item xs={2} md={2}>
                            </Grid>
                            <Grid item xs={1} md={1}>
                            </Grid>
                            <Grid item xs={1} md={1}>
                            </Grid>
                        </Grid>
                        <br />
                        <Divider style={{ marginTop: '-20px' }} />
                        <Grid item xs={12} md={12}>
                            <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                NOTA: {d.notes}
                            </span>
                        </Grid>
                    </Grid>
                }
            </Panel>
        );
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos</div>
                <Collapse
                    defaultActiveKey={[]}
                    expandIconPosition={'right'}
                >
                    {
                        props.data.filter((d) => d.ordersDetail.some(od => od.cod_process === 'MARC'))
                        .map((d, key) => {
                            return renderPanel(key, d, (od) => od.cod_process === 'MARC');
                        })
                    }
                </Collapse>
            </Grid>
            <Grid item xs={12} md={6}>
                <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos Impresos</div>
                <Collapse
                    defaultActiveKey={[]}
                    expandIconPosition={'right'}
                >
                    {
                        props.data.filter((d) => d.ordersDetail.some(od => od.cod_process === 'ALIM'))
                        .map((d, key) => {
                            return renderPanel(key, d, (od) => od.cod_process === 'ALIM');
                        })
                    }
                </Collapse>
            </Grid>
        </Grid>
    );

};

export default MarkedBoxList;
